module.exports = __webpack_public_path__ + "ath_game_web/img/8.4.0cd8e93b.png";